import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { CARDS } from '../../../constants/cards';
import { RootState } from '../../../store/store';
import { Tabs } from '../../../types/common';
import TemplatesCardList from '../../TemplatesCardList';
import TemplateTabs from '../../TemplateTabs';

const TemplatesPage: React.FC = () => {
  const { modes } = useSelector((state: RootState) => state.user);
  const [activeTab, setActiveTab] = useState<Tabs['id']>(1);

  const cards = useMemo(
    () =>
      CARDS.filter((card) => {
        const cards = modes.includes(card.mode);
        if (activeTab === 1) {
          return cards;
        }

        return cards && card.groupId === activeTab;
      }),
    [modes, activeTab]
  );

  const handleTab = (id: Tabs['id']) => {
    setActiveTab(id);
  };

  return (
    <Stack
      gap={'40px'}
      sx={{
        p: {
          mobile: '10px',
          tablet: '20px',
          laptop: '40px',
        },
      }}
    >
      <Typography variant="h1">Что будем генерировать?</Typography>
      <TemplateTabs activeTab={activeTab} onClick={handleTab} />
      <TemplatesCardList cards={cards} />
    </Stack>
  );
};

export default TemplatesPage;
